import { useTranslation } from 'react-i18next';
import offlineImage from '@assets/bundle-drop-no-internet.webp';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import styles from './AppOfflineOverlay.module.css';

export const AppOfflineOverlay = () => {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation();

  if (isOnline) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="offline-overlay-title"
      aria-describedby="offline-overlay-message"
      data-testid="offline-overlay"
    >
      <div className={styles.card}>
        <img
          src={offlineImage}
          alt={t('offline.imageAlt')}
          className={styles.image}
          draggable={false}
        />
        <h2 id="offline-overlay-title" className={styles.title}>
          {t('offline.title')}
        </h2>
        <p id="offline-overlay-message" className={styles.message}>
          {t('offline.message')}
        </p>
        <button
          type="button"
          className={styles.retryButton}
          onClick={() => window.location.reload()}
        >
          {t('offline.retry')}
        </button>
      </div>
    </div>
  );
};
